import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk'
import { createLogger } from 'redux-logger';
import reducers from './reducers';

import * as Sentry from "@sentry/react";

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const loggerMiddleware = createLogger();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
    reducers,
    composeEnhancers(
      applyMiddleware(
          thunk,
          loggerMiddleware
      ),
      sentryReduxEnhancer
    )
);

export default store;
